import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCMS } from '../context/CMSContext';
import { Pencil, Eye, LayoutDashboard, LogOut, User } from 'lucide-react';

const AdminBar = () => {
  const { user, isAuthed, logout } = useAuth();
  const { editMode, setEditMode } = useCMS();

  if (!isAuthed) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-1rem)] max-w-3xl pointer-events-none">
      <div className="pointer-events-auto bg-[#0a0a0a] text-white rounded-2xl shadow-2xl border border-white/10 px-3 py-2 flex items-center gap-2 flex-wrap justify-center">
        <div className="flex items-center gap-2 pr-3 border-r border-white/10">
          <div className="w-7 h-7 rounded-full bg-red-500 flex items-center justify-center text-[11px] font-bold uppercase">
            {(user?.name || user?.email || '?').charAt(0)}
          </div>
          <div className="hidden sm:block text-xs leading-tight">
            <div className="font-semibold">{user?.name || 'Staff'}</div>
            <div className="text-slate-400 text-[10px]">{user?.role}</div>
          </div>
        </div>

        <button
          onClick={() => setEditMode(!editMode)}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors ${
            editMode
              ? 'bg-red-500 hover:bg-red-400 text-white'
              : 'bg-white/10 hover:bg-white/20 text-white'
          }`}
        >
          {editMode ? <><Eye size={13} /> Preview</> : <><Pencil size={13} /> Edit</>}
        </button>

        <Link
          to="/admin"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-white/10 hover:bg-white/20 text-white transition-colors"
        >
          <LayoutDashboard size={13} /> Dashboard
        </Link>

        <button
          onClick={logout}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-white/10 hover:bg-white/20 text-white transition-colors"
        >
          <LogOut size={13} /> Sign out
        </button>
      </div>
    </div>
  );
};

export default AdminBar;
